import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDedf5oDbcdlHfTEcT2kSDjHyIvv5NxYEc",
  authDomain: "amcicrayazilimi.firebaseapp.com",
  projectId: "amcicrayazilimi",
  storageBucket: "amcicrayazilimi.firebasestorage.app",
  messagingSenderId: "614134974098",
  appId: "1:614134974098:web:0aff2eaa60d15ff669484b",
  measurementId: "G-9NRLHM8X25"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
